import React, { useState } from 'react';
import './App.css';
import Navigation from './Navigation.js'
import Footer from './Footer.js'

const App = () => {
  const [width, setWidth] = useState('');
  const [length, setLength] = useState('');
  const [depth, setDepth] = useState('');
  const [widthUnit, setWidthUnit] = useState('ft');
  const [lengthUnit, setLengthUnit] = useState('ft');
  const [depthUnit, setDepthUnit] = useState('in');
  const [costPerTon, setCostPerTon] = useState('');
  const [results, setResults] = useState(null);

  const unitConversion = {
    in: 0.0833333, // inches to feet
    ft: 1,         // feet to feet
    yd: 3,         // yards to feet
    cm: 0.0328084, // centimeters to feet
    m: 3.28084     // meters to feet
  };

  const calculateAsphalt = () => {
    // Convert all dimensions to feet
    const widthInFeet = width * unitConversion[widthUnit];
    const lengthInFeet = length * unitConversion[lengthUnit];
    const depthInFeet = depth * unitConversion[depthUnit];

    // Calculate volume in cubic feet
    const volumeFt3 = widthInFeet * lengthInFeet * depthInFeet;

    // Convert cubic feet to cubic yards
    const volumeYd3 = volumeFt3 / 27;

    // Estimate weight: Asphalt typically weighs about 145 lbs per cubic foot
    const weightLbs = volumeFt3 * 145;
    const weightTons = weightLbs / 2000;

    // Calculate total cost if cost per ton is provided
    const totalCost = costPerTon ? weightTons * parseFloat(costPerTon) : null;
    

    // Set the results
    setResults({
      volumeFt3: volumeFt3.toFixed(2),
      volumeYd3: volumeYd3.toFixed(2),
      weightLbs: weightLbs.toFixed(2),
      weightTons: weightTons.toFixed(2),
      totalCost: totalCost ? totalCost.toFixed(2) : null,
    });
  };

  return (
    <div>
      <header>
        <img src="/img/asphalt-driveway-calculator-logo.png" className="logo" alt="Asphalt Driveway Calculator" />
        <a href="/" className="logo-title">Asphalt Driveway Calculator</a>
        <nav className="menu">
        <Navigation />
        </nav>
      </header>
      <div className="container">
        <h1>Asphalt Driveway Calculator</h1>
        <h2>Estimate asphalt driveway cost by figuring asphalt tonnage using this asphalt driveway calculator</h2>
        <p>Enter the width, length, and depth (thickness) of the driveway.</p>
        <p>Click 'Calculate' to see the asphalt cost per ton and how much asphalt is needed for an asphalt driveway. </p>
        <br />
          <div className="input-group">
            <label>
              <b>Width:</b>
              <input
                type="number"
                value={width}
                onChange={(e) => setWidth(e.target.value)}
              />
              <select
                value={widthUnit}
                onChange={(e) => setWidthUnit(e.target.value)}
              >
                <option value="in">in</option>
                <option value="ft">ft</option>
                <option value="yd">yd</option>
                <option value="cm">cm</option>
                <option value="m">m</option>
              </select>
            </label>
          </div>
          <div className="input-group">
            <label>
             <b>Length:</b>
              <input
                type="number"
                value={length}
                onChange={(e) => setLength(e.target.value)}
              />
              <select
                value={lengthUnit}
                onChange={(e) => setLengthUnit(e.target.value)}
              >
                <option value="in">in</option>
                <option value="ft">ft</option>
                <option value="yd">yd</option>
                <option value="cm">cm</option>
                <option value="m">m</option>
              </select>
            </label>
          </div>
          <div className="input-group">
            <label>
              <b>Depth:</b>
              <input
                type="number"
                value={depth}
                onChange={(e) => setDepth(e.target.value)}
              />
              <select
                value={depthUnit}
                onChange={(e) => setDepthUnit(e.target.value)}
              >
                <option value="in">in</option>
                <option value="ft">ft</option>
                <option value="yd">yd</option>
                <option value="cm">cm</option>
                <option value="m">m</option>
              </select>
            </label>
          </div>
            <br/>
            <div className="input-group">
            <label>
              <b>Cost per Ton $ (optional):</b>
              <input
                type="number"
                value={costPerTon}
                onChange={(e) => setCostPerTon(e.target.value)}
                placeholder="Enter cost"
              />
            </label>
          </div>
          <br/>
          <div className="calculate-button">
            <button onClick={calculateAsphalt}>Calculate</button>
            </div>
            <br/>
          {results && (
            <div className="results">
              <h3>Results</h3>
              
              <p><b>Asphalt Required:</b></p>
              
                <p>{results.volumeFt3} cubic feet (ft<sup>3</sup>)</p>
                <p><b>Or </b></p>
                <p>{results.volumeYd3} cubic yards (yd<sup>3</sup>)</p>

                <br />
              
              <p><b>Asphalt Weight:</b></p>
              
                <p>{results.weightLbs} pounds (lbs)</p>
                <p><b>Or </b></p>
                <p>{results.weightTons} tons (t)</p>

                {results.totalCost !== null && (
              <>
                <br />
                <p><b>Estimated Total Cost:</b></p>
                <p>${results.totalCost}</p>
              </>
            )}
              
            </div>
          )}
        </div>
        <Footer />
    </div>
  );
};

export default App;
